import { useState, useEffect } from 'react'
import { useUserInfo } from 'pages/Header/Content/hooks/usePersonalData'

import aa from 'search-insights'

export function useUserToken(){
    const { profileGet } = useUserInfo()
    
    const [ token, setToken ] = useState(profileGet.idClaro ? `us-${profileGet.idClaro}` : typeof window !== 'undefined' ? localStorage.getItem('searchToken') : '')

    const generateRandomToken = () => {
        const array = new Uint8Array(4)
        crypto.getRandomValues(array)
        const token = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('')
        return token.toString()
    }

    const saveTokenToLocalStorage = (token) => {
        localStorage.setItem('searchToken', token)
    }

    const getTokenFromLocalStorage = () => localStorage.getItem('searchToken')

    useEffect(() => {
        if(!token){
            const tokenLocalStorage = getTokenFromLocalStorage()
            if(!tokenLocalStorage){
                const newTokenLocalStorage = generateRandomToken()
                saveTokenToLocalStorage(`an-${newTokenLocalStorage}`)
                setToken(`an-${newTokenLocalStorage}`)
                // console.log('Token generado:', newTokenLocalStorage)
            }
        }
    }, [])

    return { token }
}

export function handleAddToLocalStorage( _id, _query ){
    const productsInLocalStorage = localStorage.getItem('productsSearch')
    let products = []

    if(productsInLocalStorage){
        products = JSON.parse(productsInLocalStorage)

        const existProduct = products.find(product => product._id === _id || product._query === _query)
        if(existProduct){
            return
        }
    }

    const newProduct = {
        _id,
        _query
    }

    products.push(newProduct)

    localStorage.setItem('productsSearch', JSON.stringify(products))
}

export function handleSendEvents(event, eventName, id, __queryID, position, token, indexName){
    aa('clickedObjectIDsAfterSearch', {
        eventName,
        objectIDs: [id],
        positions: [position],
    })
}